import { Link } from 'react-router-dom';

import classNames from 'classnames';

import { Text } from '@/components/shared/Text/Text';
import { FIREBASE_TOKEN_KEY } from '@/lib/constants';

import { data } from './home-data';

const Home = () => {
  const isAuthorized = localStorage.getItem(FIREBASE_TOKEN_KEY);

  return (
    <div className="flex flex-col items-center justify-center h-screen m-auto w-full animation-fade-in">
      <Text.H1 weight="bold" className="text-4xl mb-6">
        Welcome to AddMile Hub
      </Text.H1>
      <div className="flex gap-6">
        {data.map((item) => (
          <Link
            to={isAuthorized ? item.path : item.authPath}
            key={item.title}
            className={classNames(
              'bg-white-100 p-4 rounded-[16px] w-[322px] flex justify-center flex-col align-center cursor-pointer shadow-lg',
              { 'cursor-not-allowed pointer-events-none opacity-65': !item.active },
            )}
          >
            <img src={item.image} alt={item.title} className="w-[171px] m-auto" />
            <Text.Normal className="text-center font-bold flex justify-center border-t-2 border-neutral-10 pt-4 text-black">
              {item.title}
            </Text.Normal>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Home;
